import { Breadcrumbs, Link as MuiLink, Tooltip } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import CustomModelProvider from "../CustomModelProvider";
import { styled } from "@mui/system";

const BreadcrumbModelLink = ({ to, page, value }) => {
  let pageTitle;

  const pageSplit = page.path.split("/");

  if (pageSplit.length === 1) {
    pageTitle = (data) => data._title || data.title || data.name || value;
  } else if (pageSplit.length >= 2) {
    const lastPart = pageSplit[pageSplit.length - 1];
    const lastPartCapitalized =
      lastPart.charAt(0).toUpperCase() + lastPart.slice(1);
    pageTitle = () => lastPartCapitalized;
  }

  return (
    <CustomModelProvider modelName={page.parentPage.modelName} id={value}>
      {(data) => (
        <Tooltip title={pageTitle(data)}>
          <MuiLink
            component={Link}
            underline="hover"
            color="inherit"
            to={to}
            sx={{
              maxWidth: 100,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              display: "list-item",
            }}
          >
            {pageTitle(data)}
          </MuiLink>
        </Tooltip>
      )}
    </CustomModelProvider>
  );
};

const BreadcrumbLink = ({ to, page, value }) => {
  if (page && page.type == "model") {
    return <BreadcrumbModelLink to={to} page={page} value={value} />;
  }
  const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
  return (
    <Tooltip title={page ? page.title || capitalizedValue : capitalizedValue}>
      <MuiLink
        component={Link}
        to={to}
        underline="hover"
        color="inherit"
        sx={{
          maxWidth: "100px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          display: "list-item",
        }}
      >
        {page ? page.title || capitalizedValue : capitalizedValue}
      </MuiLink>
    </Tooltip>
  );
};

const StyledBreadcrumbs = styled(Breadcrumbs)`
  .MuiBreadcrumbs-ol {
    flex-wrap: nowrap;
  }
`;

export const CustomBreadcrumbs = ({ page }) => {
  const location = useLocation();

  // Split the current pathname into breadcrumb parts
  const [root, ...pathnames] = location.pathname.split("/").filter((x) => x);

  const flatPages = [];
  let currentPage = page;
  while (currentPage) {
    flatPages.unshift(currentPage);
    currentPage = currentPage.parentPage;
  }

  const breadcrumbs = pathnames.map((value, index) => {
    const to = `/${root}/${pathnames.slice(0, index + 1).join("/")}`; // Get the full path for each breadcrumb
    const page = flatPages[index + flatPages.length - pathnames.length]; // Get the corresponding page for the breadcrumb
    return { to, page, value };
  });

  return (
    <StyledBreadcrumbs
      maxItems={4}
      aria-label="breadcrumb"
      itemsAfterCollapse={3}
    >
      {breadcrumbs.map((breadcrumb, index) => (
        <BreadcrumbLink key={index} {...breadcrumb} />
      ))}
    </StyledBreadcrumbs>
  );
};

export default CustomBreadcrumbs;
